import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap"
import { Link, useHistory } from "react-router-dom"

// action
import { registerUser, apiError, registerUserFailed } from "store/actions"

// Redux
import { connect } from "react-redux"

// import images
import weaver from "assets/images/weaver_korean.png";
import logo_long from "assets/images/logo-long.png"

import RegisterBar from "../RegisterBar";

const RegisterFinish = () => {

  const history = useHistory()

  return (
    <React.Fragment>
      <MetaTags>
        <title>회원가입 | 웨이스트버스</title>
      </MetaTags>
      <div className="account-pages my-4 px-1">
        <Container className="membership-box">
          <Link to="">
            <img src={logo_long} className="mb-4" />
          </Link>
          <RegisterBar className="margin-bottom-48" circleNumber={5} actionNumber={5} title="가입완료" />
          <Row className="justify-content-center">
            <Col md={11}>
              <Card className="overflow-hidden">
                <CardBody className="p-4">
                  <div>

                      <div className="text-center mb-5 mt-5">
                        <p className="font-weight-bold font-size-24 noMargin text-black">
                          회원가입이 완료되었습니다.
                        </p>
                        <p className="font-size-16 noMargin text-gray pt-2">
                          {'사용 안내메시지가 나올 곳입니다.'}
                        </p>
                      </div>

                      <div className="mt-5">
                        <div className="col-12 text-end mt-5">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light mt-5 w-100 font-size-16"
                            type="submit"
                            onClick={() => {history.push('login')}}
                          >
                            <img src={weaver} style={{height: 16, marginRight: 6, marginBottom: 2}} />로그인                        
                          </button>
                        </div>
                      </div>
                      
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = state => {
  const { user, registrationError, loading } = state.Account
  return { user, registrationError, loading }
}

export default connect(mapStatetoProps, {
  registerUser,
  apiError,
  registerUserFailed,
})(RegisterFinish)
